import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultFilter: '='
    },
    template: `
        <div class="table-filters">
            <form ng-submit="vm.applyFilter()" class="form form-filter">
                <div class="fields">
                    <div class="row">
                        <label class="label">{{ 'auditLog.Keyword' | translate }}</label>
                        <div class="items">
                            <input type="text" class="form-control" ng-model="vm.filter.keyword">
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'auditLog.User' | translate }}</label>
                        <div class="items">
                            <input type="text" class="form-control" ng-model="vm.filter.name">
                        </div>
                    </div>
                    <div class="row">
                      <label class="label">{{ 'auditLog.Activity' | translate }}</label>
                      <div class="items">
                        <select class="form-control"
                                ng-model="vm.filter.activity"
                                ng-options="value as name for (value, name) in vm.auditLogEnumSorted track by value">
                          <option value=""></option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'auditLog.From' | translate }}</label>
                        <div class="items">
                            <datepicker-api ng-model="vm.filter.dateStart"></datepicker-api>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'auditLog.To' | translate }}</label>
                        <div class="items">
                            <datepicker-api ng-model="vm.filter.dateEnd"></datepicker-api>
                        </div>
                    </div>
                    <div class="row">
                        <span class="label">{{ 'auditLog.Also display system entries' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label>
                                        <input ng-model="vm.filter.includeSystemEntries" type="checkbox">
                                         {{ 'general.Yes' | translate }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, AUDITLOG_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.AUDITLOG_ENUM = AUDITLOG_ENUM;
        this.filter = angular.copy(this.defaultFilter);
    }

    $onInit () {
        // sort enum labels by preserving enum keys
        this.auditLogEnumSorted = this.lodash.fromPairs(
            this.lodash.sortBy(this.lodash.toPairs(this.AUDITLOG_ENUM.LABELS), 1)
        );
    }

    applyFilter () {
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/auditlog/filter/index.js